<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加门店-->
      <div class="common-form">{{$t('菜品打印')}}</div>
      <el-form-item :label="$t('名称')" prop="name" :rules="[{ required: true, message: ' ' }]"><el-input v-model="form.name" class="max-w460"></el-input></el-form-item>
      <el-form-item :label="$t('是否开启')">
        <div>
          <el-radio v-model="form.is_open" :label="0">{{$t('关闭')}}</el-radio>
          <el-radio v-model="form.is_open" :label="1">{{$t('开启')}}</el-radio>
        </div>
      </el-form-item>
      <el-form-item :label="$t('打印类型')">
        <div>
          <el-radio @change="form.category_id = []" v-model="form.product_type" :label="0">{{$t('配送打印')}}</el-radio>
          <el-radio @change="form.category_id = []" v-model="form.product_type" :label="1">{{$t('店内打印')}}</el-radio>
        </div>
      </el-form-item>
      <el-form-item :label="$t('打印方式')">
        <div>
          <el-radio v-model="form.print_type" :label="10">{{$t('付款打印')}}</el-radio>
          <el-radio v-model="form.print_type" :label="20">{{$t('下单打印')}}</el-radio>
        </div>
      </el-form-item>

     <div style="display: flex">
       <el-form-item :label="$t('打印机类型')" prop="printer_id" :rules="[{ required: true, message: ' ' }]">
         <el-select v-model="form.printer_id" :placeholder="$t('请选择')">
           <el-option v-for="(item, index) in type" :key="index" :label="item.printer_name" :value="item.printer_id"></el-option>
         </el-select>
       </el-form-item>
       <el-form-item :label="$t('关联后厨账号')" prop="kitchen_id">
         <el-select v-model="form.kitchen_user_id" :placeholder="$t('请选择')" clearable>
           <el-option v-for="(item, index) in kitchenUserList" :key="index" :label="item.account" :value="item.kitchen_id"></el-option>
         </el-select>
       </el-form-item>
     </div>
      <el-form-item v-if="form.product_type == 1" :label="$t('菜品分组')" prop="category_id" :rules="[{ required: true, message: ' ' }]">
        <el-select v-model="form.category_id" multiple :placeholder="$t('请选择')">
          <el-option v-for="item in storeList" :key="item.category_id" :label="item.name" :value="item.category_id + ''"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.product_type == 0" :label="$t('菜品分组')" prop="category_id" :rules="[{ required: true, message: ' ' }]">
        <el-select v-model="form.category_id" multiple :placeholder="$t('请选择')">
          <el-option v-for="item in takeList" :key="item.category_id" :label="item.name" :value="item.category_id + ''"></el-option>
        </el-select>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" @click="onSubmit" :loading="loading">{{$t('提交')}}</el-button></div>
    </el-form>
  </div>
</template>

<script>
import SupplierApi from '@/api/supplier.js';

export default {
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        name: '',
        category_id: 0,
        is_open: 0,
        printer_id: '',
        product_type: 0,
        print_type: 10,
        category_id: [],
        kitchen_user_id:null,
      },
      loading: false,
      type: [],
      storeList: [],
      takeList: [],
      kitchenUserList: [],
      id: 0
    };
  },
  created() {
    this.getData();
  },
  mounted() {

  },
  methods: {
    getData() {
      let self =this;
      this.id = this.$route.query.id;
      SupplierApi.getEditPrinting(
        {
          id: self.id
        },
        true
      )
        .then(data => {
          Object.assign(self.form, data.data.model);
          console.log(self.form)
          this.storeList = data.data.storeList;
          this.takeList = data.data.takeList;
          this.type = data.data.printerList;
          this.kitchenUserList = data.data.kitchenUserList;
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      let form = self.form;
      form.id = self.id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SupplierApi.EditPrinting(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: self.$t('恭喜你，添加成功'),
                type: 'success'
              });
              self.$router.push('/supplier/printing/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/supplier/printing/edit.vue